<template>
  <div id="base-table">
    <section class="table" v-if="getWindowWidth >= changeToCardAt">
      <table ref="table">
        <thead>
          <tr>
            <th
              v-for="(item, index) in columns"
              :key="index"
              @click="sortByIndex(index, item)"
            >
              <div class="header-wrapper">
                <div class="header" v-html="$t(item.name).toUpperCase()"></div>
                <div class="icon-wrapper" v-if="item.sorting !== false">
                  <transition name="fade">
                    <toggle-icon
                      :id="`icon-${index}`"
                      :class="[
                        {
                          rotated:
                            isSortedHeaderAsc === false &&
                            isSortedHeaderIndex === index
                        }
                      ]"
                      :color="
                        isSortedHeaderIndex === index ? '#15223f' : '#b5b5b5'
                      "
                    />
                  </transition>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <!-- <tbody> -->
        <transition-group name="list" tag="tbody">
          <tr
            v-for="(item, indexRow) in sortedList"
            :key="`p+${indexRow}`"
            :class="{ isSelected: selected.includes(indexRow) }"
            @click="rowClicked(item)"
          >
            <template v-for="(col, key) in columns">
              <template v-if="col.needAction === false">
                <td @click.stop v-if="$scopedSlots[col.key]" :key="key">
                  <slot :name="col.key" :item="item"></slot>
                </td>
                <td v-else @click.stop :key="key">
                  {{ item[col.key] | tableFilter }}
                </td>
              </template>
              <template v-else>
                <td v-if="$scopedSlots[col.key]" :key="key">
                  <slot :name="col.key" :item="item"></slot>
                </td>
                <td v-else :key="key">{{ item[col.key] | tableFilter }}</td>
              </template>
            </template>
          </tr>
        </transition-group>

        <!-- </tbody> -->
      </table>
    </section>
    <section class="card-section" v-else>
      <transition-group name="list" tag="div">
        <div
          class="card-wrapper"
          v-for="(item, indexRow) in sortedList"
          :key="`div-${indexRow}`"
          @click="rowClicked(item)"
        >
          <basic-card
            class="card"
            :class="{ isSelected: selected.includes(indexRow) }"
          >
            <div class="title kaushan-font">
              <slot name="title" :item="item"></slot>
            </div>
            <template
              v-for="(col, key) in columns.filter(
                x => x.showOnMobile !== false
              )"
            >
              <template v-if="col.needAction === false">
                <div class="row" @click.stop :key="key">
                  <div class="header">
                    <div
                      class="header-column"
                      v-html="$t(col.name).toUpperCase()"
                    ></div>
                  </div>
                  <div class="content">
                    <div v-if="$scopedSlots[col.key]" :key="key">
                      <slot :name="col.key" :item="item"></slot>
                    </div>
                    <div v-else :key="key">
                      {{ item[col.key] | tableFilter }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="row" :key="key">
                  <div class="header">
                    <div
                      class="header-column"
                      v-html="$t(col.name).toUpperCase()"
                    ></div>
                  </div>
                  <div class="content">
                    <div v-if="$scopedSlots[col.key]" :key="key">
                      <slot :name="col.key" :item="item"></slot>
                    </div>
                    <div v-else :key="key">
                      {{ item[col.key] | tableFilter }}
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </basic-card>
        </div>
      </transition-group>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "BaseTable",
  props: {
    body: {
      type: [Object, Array],
      required: true
    },
    columns: {
      type: [Object, Array],
      required: true
    },
    needSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    changeToCardAt: {
      type: Number,
      required: false,
      default: 600
    },
    minWidth: {
      type: String,
      required: false,
      default: "500px"
    }
  },
  data() {
    return {
      selected: [],
      sortedList: undefined,
      isSortedHeaderIndex: undefined,
      isSortedHeaderAsc: true
    };
  },
  mounted() {
    this.$emit("selectionChanged", this.selected);
    if (this.$refs.table) {
      this.$refs.table.style["min-width"] = this.minWidth;
    }
    this.sortedList = this.body;
  },
  watch: {
    body() {
      this.sortedList = this.body;
    },
    selected() {
      this.$emit("selectionChanged", this.selected);
    },
    getWindowWidth() {
      if (this.$refs.table) {
        this.$refs.table.style["min-width"] = this.minWidth;
      }
    }
  },
  computed: {
    ...mapGetters({
      getWindowWidth: "layout/getWindowWidth"
    })
  },
  methods: {
    rowClicked(item) {
      if (this.needSelect) {
        const index = this.sortedList.indexOf(item);
        if (index !== -1) {
          if (this.selected.includes(index)) {
            const selectedIndex = this.selected.indexOf(index);
            if (selectedIndex !== -1) {
              this.selected.splice(selectedIndex, 1);
            }
          } else {
            this.selected.push(index);
          }
        }
      }
    },
    sortByIndex(index, item) {
      if (item.sorting !== false) {
        if (index !== this.isSortedHeaderIndex) {
          this.isSortedHeaderIndex = index;
          this.isSortedHeaderAsc = true;
        } else {
          this.isSortedHeaderAsc = !this.isSortedHeaderAsc;
          if (this.isSortedHeaderAsc === true) {
            this.isSortedHeaderIndex = undefined;
          }
        }
        if (this.isSortedHeaderIndex === undefined) {
          this.sortedList = this.body;
        } else {
          const helper = [...this.body];
          this.sortedList = helper.sort((a, b) => {
            //IF NUMBER CHECK START
            let isnum1 = /^\d+$/.test(a[this.columns[index].key]);
            let isnum2 = /^\d+$/.test(b[this.columns[index].key]);
            if (isnum1 && isnum2) {
              a[this.columns[index].key] = Number(a[this.columns[index].key]);
              b[this.columns[index].key] = Number(b[this.columns[index].key]);
            }
            //IF NUMBER CHECK END
            if (a[this.columns[index].key] === b[this.columns[index].key]) {
              return 0;
            }
            // nulls sort after anything else
            else if (a[this.columns[index].key] === null) {
              return 1;
            } else if (b[this.columns[index].key] === null) {
              return -1;
            } else if (this.isSortedHeaderAsc === true) {
              return a[this.columns[index].key] > b[this.columns[index].key]
                ? 1
                : -1;
            } else if (this.isSortedHeaderAsc === false) {
              return a[this.columns[index].key] > b[this.columns[index].key]
                ? -1
                : 1;
            }
          });
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#base-table {
  width: 100%;
  overflow: auto;
  .table {
    table {
      padding-right: 5px;
      padding-left: 5px;
      width: 100%;
      border-collapse: separate;
      border-spacing: 0 1rem;
      thead {
        width: 100%;
        position: relative;
        display: table-row-group;
        vertical-align: middle;
        border-color: inherit;
        tr {
          background: none;
          box-shadow: none;

          th {
            // cursor: pointer;
            padding: 0 10px;
            text-align: center;
            .header-wrapper {
              display: flex;
              justify-content: center;
              align-items: center;
              .header {
                white-space: nowrap;
                font-size: 12px;
                color: #5a5a5a;
                font-weight: bold;
                cursor: pointer;
              }
              .icon-wrapper {
                transition: all 0.5s ease-in-out;
                width: 20px;
                margin-left: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                div {
                  transition: all 0.5s ease-in-out;
                }
                .rotated {
                  transform: rotateZ(180deg);
                }
              }
            }
          }
        }
      }
      tbody {
        width: 100%;
        display: table-row-group;
        vertical-align: middle;
        border-color: inherit;
        tr {
          box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          background: #fff;
          height: 60px;
          border-radius: 15px;
          color: rgb(90, 90, 90);
          cursor: pointer;
          td {
            white-space: nowrap;
            padding: 15px;
            text-align: center;
            font-size: 12px;
          }
          td:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          td:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
      }
    }
  }
  .card-section {
    .card-wrapper {
      padding: 0 0 10px 0;
      .card {
        transition: all 0.5s ease-in;
        width: 100%;
        padding-top: 20px;
        color: #5a5a5a;
        .title {
          display: flex;
          justify-content: center;
          margin-bottom: 10px;
        }
        .row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          .header {
            display: flex;
            align-items: center;
            .header-column {
              white-space: nowrap;
              font-size: 13px;
              font-weight: bold;
              // text-align: center;
            }
          }
          .content {
            white-space: nowrap;
            font-size: 14px;
            text-align: right;
            font-size: 14px;
            white-space: pre-line;
          }
        }
      }
    }
  }
}

/deep/ .action-wrapper {
  font-weight: 600;
  transition: all 0.2s ease-in;
  cursor: pointer;
  &:hover {
    transform: scale(1.1);
  }
  &.edit {
    color: $color-success;
  }
  &.delete {
    color: $color-danger;
  }
}

.isSelected {
  box-shadow: unset !important;
  border: 2px solid $color-primary !important;
  td {
    border-bottom: 2px solid $color-primary !important;
    border-top: 2px solid $color-primary !important;
    &:first-of-type {
      border-left: 2px solid $color-primary !important;
    }
    &:last-of-type {
      border-right: 2px solid $color-primary !important;
    }
  }
}

.ps {
  width: 100%;
  height: 50vh;
  max-height: fit-content;
}
</style>
